export default "__VITE_ASSET__DBa1b5BJ__"